import * as lib from 'Root/lib/lib.js'
import ajaxMixins from 'Root/vue/mixins/ajaxMixins'
import StatisticsAccordion from 'Root/ui/components/StatisticsAccordion.js'
import Loader from 'Root/vue/components/Loader.vue'
import StatisticsFilters from 'Root/vue/components/Statistics/StatisticsFilters.vue'
import StatisticsResultsKatax from 'Root/vue/components/Statistics/StatisticsResultsKatax.vue'
import StatisticsResultsPraxeis from 'Root/vue/components/Statistics/StatisticsResultsPraxeis.vue'
import StatisticsResultsSsx from 'Root/vue/components/Statistics/StatisticsResultsSsx.vue'
import ResponseError from 'Root/vue/components/ResponseError.vue'

export default {
    components: {
        Loader,
        'statistics-filters': StatisticsFilters,
        resultsKatax: StatisticsResultsKatax,
        resultsPraxeis: StatisticsResultsPraxeis,
        resultsSsx: StatisticsResultsSsx,
        'response-error': ResponseError,
    },

    mixins: [ajaxMixins],

    data() {
        return {
            loading: false,
            hasError: false,
            errorMessages: '',

            category: null,
            region: null,
            actionType: null,

            results: null,

            resultsTypes: {
                katax: {
                    component: 'resultsKatax',
                    tabs: {
                        activeId: null,
                        links: [
                            {
                                id: 'byYear',
                                text: this.appData?.dictionary?.byYearLinkTitle,
                            },
                            {
                                id: 'byMonth',
                                text: this.appData?.dictionary?.byMonthLinkTitle,
                            },
                            {
                                id: 'byMonthMO',
                                text: this.appData?.dictionary?.byMonthAverageLinkTitle,
                            },
                        ],
                    },
                },
                praxeis: {
                    component: 'resultsPraxeis',
                    tabs: {
                        activeId: null,
                        links: [
                            {
                                id: 'byYear',
                                text: this.appData?.dictionary?.byYearLinkTitle,
                            },
                            {
                                id: 'byMonth',
                                text: this.appData?.dictionary?.byMonthLinkTitle,
                            },
                            {
                                id: 'byMonthMO',
                                text: this.appData?.dictionary?.byMonthAverageLinkTitle,
                            },
                        ],
                    },
                },
                ssx: {
                    component: 'resultsSsx',
                    tabs: {
                        activeId: null,
                        links: [
                            {
                                id: 'counts',
                                text: this.appData?.dictionary?.ssxCountsResultsLinkTitle,
                            },
                            {
                                id: 'values',
                                text: this.appData?.dictionary?.ssxValuesResultsLinkTitle,
                            },
                        ],
                    },
                },
            },

            activeResultsType: null,
        }
    },

    mounted() {
        this.$nextTick(() => {
            this._iniInfoAccordion()
        })
    },

    methods: {
        _iniInfoAccordion() {
            if (document.querySelector('.b-statistics-accordion')) {
                document.querySelector('.b-statistics-accordion').Accordion = new StatisticsAccordion(
                    document.querySelector('.b-statistics-accordion')
                )
            }
        },

        sumbitClicked(filters) {
            this.category = filters.category
            this.region = filters.region
            this.actionType = filters.actionType

            this.getResults()
        },

        resultsTabsLinkClicked(id) {
            this.activeResultsType.tabs.activeId = id

            this.scrollToResults()
        },

        getResults() {
            const payload = {
                category: this.category,
                region: this.region,
                actionType: this.actionType,
            }

            this.ajax(this.appData.configuration.dataEndpoint, payload, this.storeResults, this.showError)
        },

        storeResults(data) {
            for (const prop in this.resultsTypes) {
                if (data.results[prop] !== null) {
                    this.results = data.results[prop]
                    this.activeResultsType = this.resultsTypes[prop]
                    this.activeResultsType.tabs.activeId = this.activeResultsType.tabs.links[0]?.id
                }
            }

            this.scrollToResults()
        },

        showError() {
            this.results = null

            this.scrollToResults()
        },

        scrollToResults() {
            this.$nextTick(() => {
                const offset = window.innerWidth < lib.breakpoints.desktop ? 100 : window.innerWidth < 1280 ? 240 : 200

                lib.moveWindowToObj(jQuery(this.$el).find('.s-statistics__results'), offset * -1)
            })
        },
    },
}
